import React, { useCallback, useRef, useState, useEffect } from 'react'
import { useAppSelector } from '../store/hooks';
import { ArticleItem } from '../types/typedeclaration';
import { useSwipe } from '../store/useSwipe';
import fetchData from 'Utilis/request';
import Stories from 'components/Stories';
import {Loader} from 'components/Index';
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const Webstory = () => {
  const { onTouchStart, onTouchMove, onTouchEnd } = useSwipe();
  const settingLocalData = useAppSelector((state: any) => state.staticSettingSlice.data);
  const darkMode = useAppSelector((state: any) => state.categoryNavigation.darkmode);
  const fontSize = useAppSelector((state: any) => state.categoryNavigation.fontsize);  
  const headerHeight = useAppSelector((state: any) => state.categoryNavigation.headerHeight || 0);
  const fooNavHeight = useAppSelector((state: any) => state.categoryNavigation.fooNavHeight || 0);
  const newsContainerRef = useRef<HTMLDivElement>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [articles, setArticles] = useState<ArticleItem[]>([]);
  const [offset, setOffset] = useState(0);
  const [hasMore, setHasMore] = useState(true); 

  // Fetch initial story
  useEffect(() => {
    fetchStory(0);
  }, []);

  const fetchStory = async (increament: number) => {
    if (loading || !hasMore) return;    
    setLoading(true);
    try {      
       const result = await fetchData.getResult(`${API_BASE_URL}getWebGallery.php?limit=20&start=${increament}`);  
       
      const items = result?.galleries || [];
    
      if (items?.length > 0) {
         setArticles(prev => increament === 0 ? items : [...prev, ...items]);
        setOffset(increament + 20);       
      } else {
        setHasMore(false);
      }
    } catch (error) {
      console.error("Error fetching Story:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleScroll = useCallback(async () => {
    if (!shouldFetchMore() || loading || !hasMore) return;
    await fetchStory(offset);    
  }, [offset, loading, hasMore]);
  
  const shouldFetchMore = () => {
    if (!newsContainerRef.current) return false;
    const { scrollTop, scrollHeight, clientHeight } = newsContainerRef.current;
    return scrollTop + clientHeight >= scrollHeight - 100;
  };
  const storyTitle = settingLocalData?.menu.find((item: any) => item.id === 'web-story')?.title || "वेब स्टोरी";
  // console.log(articles, " articles print")
  return (
    <div className={`font-sans min-h-screen ${darkMode ? 'bg-gray-900 text-white' : 'bg-gray-100 text-gray-900'}`}>
      <main
        className="story-container"
        ref={newsContainerRef}
        onScroll={handleScroll}
        style={{ height: `calc(100vh - ${fooNavHeight+15}px)`, overflowY: 'auto', paddingTop:headerHeight+15 }}      
       onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}>        
        <div className="story-inner-container">
            <Stories
            darkMode={darkMode}
            fontSize={fontSize}
            articles={articles}               
            inlineView={true}
            title={storyTitle}/>
          {loading && <Loader darkMode={darkMode}/>}
          {!hasMore && <div className="text-center py-4">No more Stories to load</div>}
        </div>
      </main>
    </div>
  )
}

export default Webstory;